import { useCallback, useEffect, useState } from 'react';

import { ModifiedLeaderboardPlayer } from '../leaderboard.types';
import { fetchLeaderboard } from '../utils/leaderboardApi';

import { useGlobalStore } from 'shared/store/globalStore';
import { buildLeaderboardMap } from 'shared/utils/pretty-tx';

export function useLeaderboard() {
  const [data, setData] = useState<ModifiedLeaderboardPlayer[] | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const setLeaderboardMap = useGlobalStore((state) => state.setLeaderboardMap);
  const fetchData = useCallback(async (controller?: AbortController) => {
    setLoading(true);
    setError(null);
    try {
      const players = await fetchLeaderboard(controller?.signal);
      if (players.rows) {
        const oneHundredPercent = players.rows[0][3];

        const updatedRows = players.rows.map((row) => ({
          walletAddress: row[0],
          discordId: row[1],
          discordUsername: row[2],
          xp: row[3],
          nftsTotal: row[4],
          gamesTotal: row[5],
          gamesWon: row[6],
          elo: row[7],
          percent: (row[3] / oneHundredPercent) * 100,
        }));
        const leaderboardMap = buildLeaderboardMap(updatedRows);
        setLeaderboardMap(leaderboardMap);

        setData(updatedRows);
      } else {
        setError('No data found');
      }
    } catch (e: any) {
      setError(e?.message ?? 'Unknown error');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    fetchData(controller);
    return () => controller.abort();
  }, [fetchData]);

  return { data, loading, error, refresh: () => fetchData() };
}
